// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"88da0291","354":"aef42382","593":"16da0a9c","760":"16da0a9c","960":"16da0a9c"}[chunkId] + ".chunk.css";
};